// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--r5rPm","textarea":"dece2e673c--textarea--_8fKw","buttons":"dece2e673c--buttons--yVuG7"};